{
	"title": "Proyectos",
	"table": {
		"reference": "Referencia",
		"quantity": "Cantidad total",
		"savings": "Reducciones totales de carbono",
		"fetchError": "No se pudieron recuperar los proyectos"
	},
	"showProjectsHistoryTitle": "Mostrar historial de proyectos",
	"noProjects": {
		"createDeclaration": "Crea tu primera declaración",
		"description": "Puede crear declaraciones para uno o más materiales haciendo clic en \"Crear declaración\"."
	}
}
